module.exports = __webpack_public_path__ + "img/access.91c3a356.svg";